import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect-Route für /users → /persons/fans (Abwärtskompatibilität).
 * Bestehende Bookmarks und Links auf /users werden auf die neue Personen-Sub-Navigation weitergeleitet.
 * ?type=clerk wird auf /persons/users weitergeleitet.
 */
export const Route = createFileRoute('/_authenticated/users/')({
  beforeLoad: ({ search }) => {
    const s = search as Record<string, unknown>;
    if (s.type === 'clerk') {
      throw redirect({ to: '/persons/users' });
    }
    throw redirect({ to: '/persons/fans' });
  },
  validateSearch: (search: Record<string, unknown>): { type?: string } => ({
    type: typeof search.type === 'string' ? search.type : undefined,
  }),
  component: () => null,
});
